import { ActionTree } from 'vuex';
import { RootState } from '@/store/types';
import { AuthState } from './types';

const actions: ActionTree<AuthState, RootState> = {
  setAuthenticated({ commit }, params) {
    commit('SET_AUTHENTICATED', params.authenticated);
  },
  setUser({ commit }, params) {
    commit('SET_USER', params.user);
  },
  setTeam({ commit }, params) {
    commit('SET_TEAM', params.team);
  },
  setTeamError({ commit }, params) {
    commit('SET_TEAM_ERROR', params);
  },
  setGroups({ commit }, params) {
    commit('SET_GROUPS', params.groups);
  }
};

export default actions;
